import { ReactElement, useContext } from "react"

import { FormLabel, TextArea, TextInput } from "@wfp/ui"

import { DataUploadContext, initialFilters } from "../../../providers/DataUploadContext"

import FileUploader from "../../Shared/ExcelUploader/FileUploader"
import CountrySelector from "../../Shared/HeaderFilters/AssociatedCountriesSelector"

type Props = {
  withMappingName?: boolean
}

const DataExcel = ({ withMappingName }: Props): ReactElement => {
  const { filters, setFilters } = useContext(DataUploadContext)

  return (
    <div>
      <p className="text-sm text-gray-500 mb-2">
        Upload your price data Excel file and provide required details to start the process.
      </p>
      <FormLabel className="required">Country</FormLabel>
      <CountrySelector
        allowAll={false}
        onSelect={country => setFilters({ ...initialFilters, adm0Code: country?.value })}
        value={filters.adm0Code}
      />

      {withMappingName && (
        <div className="mt-3 xl:w-1/2 w-full">
          <FormLabel className="required">Mapping Schema Name</FormLabel>
          <TextInput
            name="mapping-name"
            placeholder="Type mapping schema name..."
            onChange={e => setFilters({ ...filters, mappingSchemaName: e.target.value })}
            value={filters.mappingSchemaName}
            className="custom-text-field"
          />
        </div>
      )}

      <div className="my-3 xl:w-1/2 w-full">
        <TextArea
          name="note"
          className="textarea-input"
          rows={4}
          labelText="Notes"
          placeholder="Add notes (optional)"
          onChange={e => setFilters({ ...filters, note: e.target.value })}
          value={filters.note}
        />
      </div>

      <div className="mt-3 xl:w-1/2 w-full">
        <FormLabel className="required">Excel file</FormLabel>
        <FileUploader
          onChange={files => setFilters({ ...filters, file: files?.[0] ?? null })}
          files={filters.file ? [filters.file] : []}
        />
      </div>
    </div>
  )
}

export default DataExcel
